<template>
  <div class="block-holder" :class="getResponsiveClass">
    <div class="block-feature">
      <app-link :id="linkID" type="collection" class="collection__tile link-unstyle lazyload" :style="getBackground" :alt="title">
        <div class="overlay" />
        <h3 class="uppercase" v-html="getHeadingText(title)" />
        <div class="text-center">
          <span class="btn-underlined-light-sm">
            {{ description }}
          </span>
        </div>
      </app-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Collections',
  props: {
    imgURL: { type: String, required: true },
    linkID: { type: String },
    linkType: { type: String },
    title: { type: String, required: true },
    description: { type: String, required: true },
    responsive: { type: Boolean, default: true },
  },
  computed: {
    getResponsiveClass() {
      return {
        responsive: this.responsive,
      };
    },
    getBackground() {
      return {
        backgroundImage: `url("${encodeURI(this.imgURL)}")`,
      };
    },
  },
  methods: {
    getBackgroundImage(url) {
      return {
        backgroundImage: `url(${url})`,
      };
    },
    getHeadingText(text) {
      const regex = /\b(the|by|to|through|into|in|at|on|of|for|and|near|a|with|de|la)\b/gi;
      return text.replace(regex, '<span class="lowercase">$1</span>');
    },
  },

};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/settings/_config.scss";

// Must be kept at 3:2 ratio
$image-width: 412px;
$image-height: 515px;

.lazy {
   background-image: none !important;
   background-color: $solitude;
}

.block-feature {
  min-width: $image-width;
  @media (max-width: 768px) {
    max-width: 280px;
    min-width: 280px
  }
}

.block-image-container {
  overflow: hidden;
  min-width: $image-width;
  height: $image-width;
}

.block-image {
  min-width: $image-width;
  height: $image-height;
  display: block;
  cursor: pointer;
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-color: $silver;
}

.collection__tile {
  position: relative;
  padding: 1em 2em;
  margin: 0 1em;
  height: 515px;
  // min-width: 300px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-size: cover;
  @media screen and (max-width: 480px) {
    margin: 0 0 1em 0;
    width: 100%;
    height: 400px;
  }
  h3 {
    position: relative;
    z-index: 2;
    font-size: 40px;
    font-family: $font-family-editorial;
    color: $stoneWhite;
    line-height: 1.2;
    letter-spacing: 0 !important;
    @media screen and (max-width: 480px) {
      font-size: 32px;
    }
  }
}

.responsive {
    @media (max-width: 1024px) {
    .block-holder{
        justify-content:center;
        flex-direction: column;
        flex-wrap: wrap;
        width: auto;
    }

    .block-feature {
        width: 90%;
    }

    .block-image {
        width: 100%;
    }
 }

}

</style>
